import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { APIS, CONSTANTS } from "./core/constants/constants";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AppService {
  isNew = CONSTANTS.isNewAPIs;
  private httpClient1: HttpClient;
  constructor(
    private httpClient: HttpClient,
    httpBackend: HttpBackend,
  ) {
    this.httpClient1 = new HttpClient(httpBackend);
  }

  public emailOnly(email): boolean {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email)) {
      // Invalid Email.
      return false;
    }
    return true;
  }

  paymentConfirm(reqBody) {
    const url = APIS.BASEURL + "" + APIS.paymentConfirm;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }
  terms(reqData) {
    const url = APIS.BASEURL + "" + APIS.addTnC;
    return this.httpClient.post(url, reqData).toPromise();
  }
  payment(reqBody) {
    const url = APIS.BASEURL + "" + APIS.payment;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }
  getOnePlan(): Observable<any> {
    const url = APIS.BASEURL + "" + APIS.getOnePlan;
    return this.httpClient.get(url, {});
  }
  updateEatenFoodItems(reqBody) {
    reqBody["customerId"] = CONSTANTS.email;
    const url = APIS.refreshBaseUrl + "" + APIS.updateEatenFoodItems;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }
  dietPlan(reqBody) {
    //const url = APIS.BASEURL + "" + APIS.updateDiet;
    const url = APIS.BASEURL + "" + APIS.dietplan;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }

  downloadPdfFromApi(
    token,
    dateRange,
    date,
    comp_id = "alyve.health",
    user_id,
  ): Observable<Blob> {
    const url =
      APIS.pithanURL +
      `${APIS.downloadPdfApi}?auth_token=${token}&date_range=${dateRange}&date=${date}&company_id=${comp_id}&user_id=${user_id}`;
    return this.httpClient.get(url, { responseType: "blob" });
  }

  downloadPdfFromApiNew1(
    comp_id = "alyve.health",
    user_id,
    dietitian_name,
    dietitan_email,
    response_type,
    design,
  ): Observable<any> {
    return this.httpClient.get(
      this.buildPdfUrl(
        comp_id,
        user_id,
        dietitian_name,
        dietitan_email,
        response_type,
        design,
      ),
      this.pdfRequestOptions(response_type),
    );
  }

  getUserAgentType(ua: string): "Android App" | "IOS App" | "Web" {
    if (ua === "RedcliffeLabsAndroidApp" || ua === "RedcliffeLabs/1.0.47") {
      return "Android App";
    } else if (ua === "RedcliffeLabsIOSApp") {
      return "IOS App";
    } else {
      return "Web";
    }
  }

  downloadPdfFromApiNew(
    comp_id = "alyve.health",
    user_id,
    dietitian_name,
    dietitan_email,
    response_type,
    design,
  ): Observable<any> {
    return this.httpClient.get(
      this.buildPdfUrl(
        comp_id,
        user_id,
        dietitian_name,
        dietitan_email,
        response_type,
        design,
      ),
      this.pdfRequestOptions(response_type),
    );
  }

  private buildPdfUrl(
    comp_id,
    user_id,
    dietitian_name,
    dietitan_email,
    response_type,
    design,
  ): string {
    const params = {
      company_id: comp_id ?? "",
      user_id: user_id?.trim() ?? "",
      trigger_webhook: "true",
      dietitian_name: dietitian_name?.toString()?.trim() ?? "",
      dietitian_email: dietitan_email?.trim() ?? "",
      response_type: response_type ?? "",
      design: design ?? "",
    };
    const query = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");

    return `${APIS.pithanURL}${APIS.downloadPdfApiNew}?${query}`;
  }

  // response_type=file returns raw PDF bytes, so the default JSON parsing has to
  // be turned off — otherwise Angular fails on "%PDF-1.4" with a status-200 error.
  private pdfRequestOptions(response_type): any {
    return response_type === "file" ? { responseType: "blob" } : {};
  }

  getDietPlans(isDetox, date, country, recommended) {
    if (this.isNew) {
      country = country ? country : "IND";
      let reqBody = {
        date: date,
        // "refresh": true,
        customerId: CONSTANTS.email,
        detox: isDetox,
      };
      if (isDetox) {
        let b2 = 1200,
          b3 = 1800,
          c2 = 500,
          c3 = 1000,
          b4 = recommended;
        recommended = Math.round(
          recommended - (c2 + ((c3 - c2) * (b4 - b2)) / (b3 - b2)),
        );
        reqBody["dietPlanName"] = "Detox";
        reqBody["refresh"] = true;
        reqBody["recommendedCalories"] = recommended;
      }
      // if(isNew) reqBody["refresh"] = true;
      const url = APIS.refreshBaseUrl + "" + APIS.dietPlansDirect; //+ "&detox=" + isDetox;
      return this.httpClient.post(url, reqBody, {}).toPromise();
    } else {
      country = country ? country : "IND";
      const url =
        APIS.BASEURL +
        "" +
        APIS.dietPlans +
        "?date=" +
        date +
        "&country=" +
        country +
        "&detox=" +
        isDetox;
      return this.httpClient.get(url, {}).toPromise();
    }
  }
  postDiet(reqBody) {
    const url = APIS.BASEURL + "" + APIS.updateDiet;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }
  updateTargetWeight(reqBody) {
    const url = APIS.BASEURL + "" + APIS.updateTargetWeight;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }
  getLocalData(url) {
    return this.httpClient.get(url, {}).toPromise();
  }
  getProfile() {
    const url = APIS.BASEURL + "" + APIS.profile;
    return this.httpClient.get(url, {}).toPromise();
  }
  getEditProfilePermission(email) {
    const url = `${APIS.nodeBaseUrl}dietitian/assignedDietitianRecord?userId=${email}`; //APIS.nodeBaseUrl + '' + APIS.DietitianActions+`${email}`;
    return this.httpClient.get(url, {}).toPromise();
  }

  getDietitianRecord(userid: string) {
    return this.httpClient.get(
      `${APIS.nodeBaseUrl}dietitian/assignedDietitianRecord?userId=${userid}`,
    );
    //APIS.nodeBaseUrl +
  }

  // getEditProfilePermission(email) {
  //   const url = APIS.nodeBaseUrl + '' + APIS.DietitianActions+`${email}`;

  //   return this.httpClient.get(url, {}).toPromise();
  // }
  getDefaultData(token) {
    const url = APIS.BASEURL + "" + APIS.defaultDetail;
    console.log("manual header", token);
    return this.httpClient.get(url, {}).toPromise();
  }

  getDefaultDataDiet(id: any) {
    id = id ? id : "IND";
    const url = APIS.BASEURL + "" + APIS.defaultDetail + "?country=" + id;
    return this.httpClient.get(url, {}).toPromise();
  }

  postDemographic(reqBody) {
    const url = APIS.BASEURL + "" + APIS.updateDemographic;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }

  postLifeStyle(reqBody) {
    // reqBody.lifeStyle.firstConsult= localStorage.getItem("clientId")==="orthocure"? false:null;
    const url = APIS.BASEURL + "" + APIS.updateLifeStyle;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }

  updateWeight(reqBody) {
    const url = APIS.BASEURL + "" + APIS.updateWeight;
    console.log(url + ":-update weight:-", reqBody);

    return this.httpClient.post(url, reqBody, {}).toPromise();
  }

  updateProfile(reqBody) {
    const url = APIS.BASEURL + "" + APIS.updateProfile;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }

  updateDietPlan(reqBody) {
    console.log(reqBody);
    reqBody.customerId = CONSTANTS.email;
    const url = APIS.refreshBaseUrl + "" + APIS.updateDietPlan;
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }

  registration(reqBody) {
    const url =
      "https://app.smartdietplanner.com/api/authenticateExternal?key=NEWMI2022";
    return this.httpClient.post(url, reqBody, {}).toPromise();
  }

  async shorten(url: string) {
    const api = `https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`;
    return this.httpClient1.get(api, { responseType: "text" });
  }
  postOptionFoodList(foodCodeList) {
    let url;
    if (this.isNew) {
      ((foodCodeList["customerId"] = CONSTANTS.email),
        (url = APIS.refreshBaseUrl + "" + APIS.optionSelectionNew));
    } else {
      url = APIS.BASEURL + "" + APIS.optionSelection;
    }

    return this.httpClient.post(url, foodCodeList, {}).toPromise();
  }

  updateFoodfromScannedImage(foodCodeList) {
    let url;
    if (this.isNew) {
      ((foodCodeList["customerId"] = CONSTANTS.email),
        (url = APIS.refreshBaseUrl + "" + APIS.optionSelectionNew));
    } else {
      url = APIS.BASEURL + "" + APIS.optionSelection;
    }

    return this.httpClient.post(url, foodCodeList, {}).toPromise();
  }

  fetchCustDailyDiets(data: any) {
    // id = id ? id : 'IND';
    const url =
      APIS.refreshBaseUrl +
      "" +
      APIS.fetchCustDailyDiets +
      `?fromDate=${data.fromDate}&dateRange=${data.dateRange}`;
    return this.httpClient.get(url, {}).toPromise();
  }

  getInstructionData(data) {
    const url = APIS.instructionApiUrl + data;
    return this.httpClient1.get(url, {}).toPromise();
  }

  updateFoodDetailPraveenApi(data) {
    const url =
      "https://app.smartdietplanner.com:8443/api/customer/updateDietPlan";
    return this.httpClient.post(url, data).toPromise();
  }

  foodImageSend(formdata): Observable<any> {
    const url = "https://aiapi.fitrofy.com/api/identify-food";
    const headers = new HttpHeaders();
    headers.append("Content-Type", "multipart/form-data");
    return this.httpClient1.post(url, formdata, { headers: headers });
  }
  barcodeImageSend(formdata): Observable<any> {
    const url = "https://aiapi.fitrofy.com/api/barcode-number";
    const headers = new HttpHeaders();
    headers.append("Content-Type", "multipart/form-data");
    return this.httpClient1.post(url, formdata);
  }
  barcodeFootnoteImageSend(itemNumber): Observable<any> {
    const url = "https://aiapi.fitrofy.com/api/barcodeid-footnote";
    return this.httpClient1.post(url, { barcode_number: `${itemNumber}` });
  }
  nutritionLabelSend(formdata): Observable<any> {
    const url = "https://aiapi.fitrofy.com/api/nutrition-label";
    const headers = new HttpHeaders();
    headers.append("Content-Type", "multipart/form-data");
    return this.httpClient1.post(url, formdata);
  }
  nutritionValueScan(name): Observable<any> {
    const url = "https://aiapi.fitrofy.com/api/scan";
    const headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    return this.httpClient1.post(
      url,
      { food_name: name, health_conditions: "" },
      { headers: headers },
    );
  }

  sendChat(payload): Observable<any> {
    const url = "https://aiapi.fitrofy.com/chat";
    const headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    return this.httpClient1.post(url, payload, { headers: headers });
  }
}
